import { render } from "./EditableTable.vue?vue&type=template&id=9523078a&scoped=true"
import script from "./EditableTable.vue?vue&type=script&lang=js"
export * from "./EditableTable.vue?vue&type=script&lang=js"

import "./EditableTable.vue?vue&type=style&index=0&id=9523078a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9523078a"]])

export default __exports__